var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _c(
      "div",
      { staticClass: "flex justify-between" },
      [
        _c("TotalCounter", {
          staticClass: "self-end",
          attrs: { total: _vm.total, pageName: _vm.pageName },
        }),
        _vm._t("default"),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }